import { render } from "./viewWeastageData.vue?vue&type=template&id=306c4796&ts=true"
import script from "./viewWeastageData.vue?vue&type=script&lang=ts"
export * from "./viewWeastageData.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__